import { TraverseJoint } from './traverse-joint.js';

const GetAllBones = (joint) => {
    const bones = new Set();
    const callback = (j) => {
        for (const b of j.bones) {
            bones.add(b);
        }
    };
    TraverseJoint(joint, [], callback);
    return Array.from(bones);
};

export { GetAllBones };
//# sourceMappingURL=get-all-bones.js.map
